const TableItemsPerPage = ({ itemsPerPage, onChange, itemsPerPageOptions }) => {
  return (
    <label className="per-page-select" style={{ height: '35px', marginRight: '50px' }}>
      <span style={{ marginRight: '5px' }}>Rows:</span>
      <select value={itemsPerPage} onChange={(e) => onChange(parseInt(e.target.value))}>
        {itemsPerPageOptions.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    </label>
  );
};

export default TableItemsPerPage;
